﻿import onReady from '../utils/onReady';
import { addEvent, delegateEvent } from '../utils/events';
import * as formError from '../utils/formError';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class Payment {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container,
            total: container.querySelector("#totalpayment"),
            boxes: ".payment .section input[type=checkbox].lejerbo-input",
            selectedBoxes: ".payment .section input[type=checkbox]:checked.lejerbo-input",
            rowSelector: ".list-row",
            priceSelector: ".price",
            paymentTermsAccepted: container.querySelector("#PaymentTermsAccepted"),
			form: container.querySelector("form")
            
        };

        // Put your other DOM-specific initializations here, and get your class moving!
        delegateEvent(this.dom.boxes, "change", (ev) => {
            // A box has been checked => update total
            this.dom.total.innerHTML = this.calculateTotal();
        });

	    addEvent(this.dom.form, "submit", (ev) => {
	    	if (!this.dom.paymentTermsAccepted.checked) {
	    		ev.preventDefault();
	    		formError.addErrorClass(this.dom.paymentTermsAccepted.closest(".PaymentTermsAccepted"), "Du skal acceptere handelsbetingelserne", "change");
		    }	
	    });

    }

    getSelectedRows() {
        let boxes = [];
        [].forEach.call(this.dom.container.querySelectorAll(this.dom.selectedBoxes), (box) => {
            boxes.push(box.closest(this.dom.rowSelector));
        });
        return boxes;
    }

    calculateTotal() {
        let sum = 0.0;
        let selectedrows = this.getSelectedRows();
        [].forEach.call(selectedrows, (row) => {
            let priceCell = row.querySelector(this.dom.priceSelector);
            //let price = parseFloat(priceCell.getAttribute("data-price")); //20200602 decimals like 300,83 is allowed
            let price = parseFloat(priceCell.getAttribute("data-price").replace(",","."));
            sum += price;
        });
        return sum;
    }
}

export default Payment;